import { toast } from "react-toastify";
import { axios } from "../../../utils/axios";
import { toastOptions } from "../../../config/toast";

export const handleBusquedaPorDominio = async (
  submittedData,
  setInfracciones,
  setErrorNoHayInfraccion,
  setCountdown,
  setValor,
  setDatosSobre,
  setConstancia
) => {
  // console.log(submittedData)
  // return

  setCountdown(5);
  setInfracciones([]);
  setErrorNoHayInfraccion("");

  const result = await axios().post(`infraccion_patente_p`, submittedData);
  const { status } = result;
  const { data, error,params  } = result.data;
  
  
  if (data) {
    setInfracciones(data);
    setValor(submittedData?.valor);
    setDatosSobre(submittedData?.datos_sobre);
  }

  if (error) {
    if (status == 404 && params) {
      setConstancia(params)
    }
    if (status !== 422) {
      if (error === "No se encontraron infracciones") {
        setErrorNoHayInfraccion("No se detectaron infracciones");
        setValor(submittedData?.valor);
        setDatosSobre(submittedData?.datos_sobre);
      } else {
        setConstancia(null)
        toast.error(error, toastOptions);
      }
    } else {
      setConstancia(null)
      Object.values(error).map((err) => toast.error(err[0], toastOptions));
    }
  }

  const timer = setInterval(() => {
    setCountdown((prevCountdown) => {
      if (prevCountdown === 1) {
        clearInterval(timer);
        return 0;
      }
      return prevCountdown - 1;
    });
  }, 1000);
};

export const handleGuardarCorreo = async (
  submittedData,
  setValor,
  setDatosSobre,
  setCorreoElectronico,
  setVerify,
  handlerLoading
  // handlerModal
) => {
  // handlerLoading({ loading: true, loadName: "guardar_correo" });
  const result = await axios().post(`guardar_correo_busqueda_infracciones`, submittedData);
  const { status } = result;
  const { data, error } = result.data;

  if (data) {
    toast.success(<p className="fw-semibold text-black mb-0">{data}</p>, toastOptions);
    setValor(null);
    setDatosSobre(null);
    setCorreoElectronico(null);
    setVerify(false)
    // handlerModal({ modal: false, modalName: "captcha" });
    // handlerLoading({ loading: false, loadName: "verificar" });
  }

  if (error) {
    if (status !== 422) {
      toast.error(error, toastOptions);
    } else {
      Object.values(error).map((err) => toast.error(err[0], toastOptions));
    }
  }
  // handlerLoading({ loading: false, loadName: "guardar_correo" });
};
